const SET_COMMUNITY_COLLECTIONS = (state, { collections }) => {
  state.selectedCommunity.collections = collections;
};

export default SET_COMMUNITY_COLLECTIONS;
